module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/advantages_2_5-2ca1d262f986208fa3920e670de295ce.png";